import React, { useLayoutEffect, useRef } from "react";
import "./webaudio-controls/webaudio-controls-module";
export const WebAudioParam = (props) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const { current } = ref;
        if (current !== undefined) {
            // @ts-ignore
            current === null || current === void 0 ? void 0 : current.addEventListener("change", (event) => {
                props.onParamInput &&
                    (props === null || props === void 0 ? void 0 : props.onParamInput(parseFloat(event.target.value)));
                props.onParamEvent && (props === null || props === void 0 ? void 0 : props.onParamEvent(event));
            });
        }
    }, [ref]);
    // @ts-ignore
    return (React.createElement("webaudio-param", { id: (props === null || props === void 0 ? void 0 : props.id) ? props.id : "param", ref: ref, ...props }));
};
